import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/cle';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiError, FormExclusao } from '../../../services/tipos';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';

interface LegendaOrigemExclusaoProps {
    show: boolean;
    onHide: () => void;
    idLegendaOrigem: string;
    onExcluir: (valor: boolean) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function LegendaOrigemExclusao(props: LegendaOrigemExclusaoProps) {
    const [origem, setOrigem] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoLegendaOrigem, setCarregandoLegendaOrigem] = useState<boolean>(false);

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        if (props.show) {
            setCarregandoLegendaOrigem(true);
            api.get(`/LegendaOrigem/${props.idLegendaOrigem}`)
                .then(response => {
                    setOrigem(response.data.origem);
                    setCarregandoLegendaOrigem(false);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregandoLegendaOrigem(false);
                    props.tratarErro(error, 'Não foi possível realizar a consulta: ');
                });
        }
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        api.delete(`/LegendaOrigem/${props.idLegendaOrigem}`, data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível excluir a legenda origem: ');
            });
    }

    function informarSucesso() {
        props.onHide();
        props.onExcluir(true);
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoLegendaOrigem
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            titulo={`Deseja realmente excluir a legenda origem ${origem}?`} />
                }
            </Modal.Body>
        </Modal>
    );
}

export default LegendaOrigemExclusao;